import React from "react";
import { deBaseAFechaLocal } from "../../../utils/Tools";

const PuntosDeEmbarque = ({ puntosDeEmbarques, onPuntoDeEmbarqueChange, puntoDeEmbarqueSeleccionado }) => {
  return (
    <section className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 payment clearfix">
      <h2>Puntos de Embarque</h2>
      <hr />
      <h4>
        <i
          className="material-icons iconos-pagos"
          title="Ver Puntos de Embarque"
        >
          departure_board
        </i>{" "}
        elija el punto de embarque
      </h4>
      <ul className="row">
        {puntosDeEmbarques.map((puntoDeEmbarque) => {
          return (
            <li
              className="liPuntosDeEmbarque"
              key={puntoDeEmbarque.idPuntoDeEmbarque}
            >
              <input
                className="radioPuntoEmbarque"
                type="radio"
                name="puntoDeEmbarque"
                onChange={onPuntoDeEmbarqueChange}
                value={puntoDeEmbarque.idPuntoDeEmbarque}
                checked={puntoDeEmbarqueSeleccionado.idPuntoDeEmbarque === puntoDeEmbarque.idPuntoDeEmbarque}
              />
              <label>
                {puntoDeEmbarque.denominacion} (
                {puntoDeEmbarque.fechaHora
                  ? deBaseAFechaLocal(puntoDeEmbarque.fechaHora.split(" ")[0])
                  : ""}
                )
              </label>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default PuntosDeEmbarque;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/Pago/puntosDeEmbarque.js